<template>
  <div class="w-100">
    <div class="w-100" v-if="source_data.address.full == ''">
      <button class="g-btn g-btn-secondary-outline g-btn-lg w-100" @click="toggleDelivery()">Add delivery address</button>
      <!-- <label class="body-3 mb-1 d-block">Delivery Address</label>
      <textarea class="p-2-5 body-2-1 w-100 border-form radius-6" row="4" v-model="full_address"></textarea> -->
    </div>
    <div class="w-100" v-else>
      <div class="w-100 radius-6 border-form mb-4" v-if="$isNotEmpty(selected.map.center.lat)" style="overflow: hidden;">
        <gmap-map
          :center="selected.map.center" 
          :options="selected_map_options"
          :zoom="15" 
          style="width:100%;  
          height: 200px;"
          :draggable="false">
          <gmap-marker :position="selected.map.markers.position" :draggable="false"></gmap-marker>
        </gmap-map>
      </div>
      <div class="w-100 mb-4 border-form radius-6 p-3 d-flex justify-content-between">
        <div class="align-items-center lh-1">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_700_18)">
              <path
                d="M12.0461 24.0952C18.6109 24.0952 24.0461 18.6482 24.0461 12.0952C24.0461 5.53052 18.5992 0.0952148 12.0344 0.0952148C5.48145 0.0952148 0.0461426 5.53052 0.0461426 12.0952C0.0461426 18.6482 5.49321 24.0952 12.0461 24.0952ZM12.0461 22.0953C6.49322 22.0953 2.05792 17.6482 2.05792 12.0952C2.05792 6.54229 6.48145 2.09522 12.0344 2.09522C17.5874 2.09522 22.0462 6.54229 22.0462 12.0952C22.0462 17.6482 17.5991 22.0953 12.0461 22.0953Z"
                class="fill-primary" />
              <path
                d="M5.64615 17.1776C5.64615 17.6365 5.89321 17.8953 6.34027 17.8953C6.50497 17.8953 6.65792 17.8365 6.85792 17.7305L9.43439 16.3306V6.17758C9.32851 6.22464 9.21087 6.28346 9.08145 6.35406L6.17557 8.01288C5.78733 8.23641 5.64615 8.49524 5.64615 8.93053V17.1776ZM10.2697 16.2129L13.3638 17.9541C13.458 18.0129 13.5638 18.0482 13.6462 18.0717V8.05993L10.6227 6.21287C10.505 6.14229 10.3991 6.09523 10.2697 6.07169V16.2129ZM14.4815 18.0482C14.5403 18.0364 14.5991 18.0129 14.6697 17.9776L17.858 16.1658C18.2462 15.9424 18.3991 15.6834 18.3991 15.26V6.97758C18.3991 6.53053 18.1403 6.28346 17.705 6.28346C17.5403 6.28346 17.3873 6.34229 17.1873 6.44816L14.4815 7.94229V18.0482Z"
                class="fill-primary" />
            </g>
            <defs>
              <clipPath id="clip0_700_18">
                <rect width="24" height="24.0118" fill="white" transform="translate(0.0461426 0.0952148)" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="align-items-center w-90">
          <p class="mb-1 body-3">Full Address</p>
          <p class="mb-0 body-2-2 ">{{ source_data.address.full }}</p>
        </div>
      </div>
      <div v-if="source_data.address.landmark != ''" class="w-100 mb-4 border-form radius-6 p-3 d-flex justify-content-between">
        <div class="align-items-center lh-1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="directions_24px">
              <path id="icon/maps/directions_24px" fill-rule="evenodd" clip-rule="evenodd"
                d="M22.4275 10.5931L13.4175 1.58312C12.6675 0.833125 11.3475 0.823125 10.5875 1.58312L1.58746 10.5831C0.807457 11.3631 0.807457 12.6231 1.58746 13.4031L10.5875 22.4031C10.9775 22.7931 11.4875 22.9831 11.9975 22.9831C12.5075 22.9831 13.0175 22.7931 13.4075 22.4031L22.3975 13.4131C23.1875 12.6531 23.1975 11.3931 22.4275 10.5931ZM12.0075 20.9931L3.00746 11.9931L12.0075 2.99312L21.0075 11.9931L12.0075 20.9931ZM7.99746 15.0031V11.0031C7.99746 10.4531 8.44746 10.0031 8.99746 10.0031H13.9975V7.50312L17.4975 11.0031L13.9975 14.5031V12.0031H9.99746V15.0031H7.99746Z"
                class="fill-primary" />
            </g>
          </svg>
        </div>
        <div class="align-items-center w-90">
          <p class="mb-1 body-3">Landmark</p>
          <p class="mb-0 body-2-2 ">{{ source_data.address.landmark }}</p>
        </div>
      </div>
      <button class="g-btn g-btn-secondary g-btn-lg w-100" @click="toggleDelivery()">Edit Delivery Address</button>
    </div>


    <!-- INPUT ADDRESS & SELECT LOCATION FROM MAP -->
    <popup-detail
      direction="bottom" 
      :show="show"
      wrapper_size="mobile"
      :use_footer="view_mode == 'map'"
      title="Order Location"
      no_close_backdrop
      @close="toggleDelivery">
      <template v-slot:body>
        <div class="w-100">
          <template v-if="view_mode == 'map'">
            <div v-if="is_load.map" class="w-100 py-5 text-center">
              <loader />
            </div>
            <template v-else>
              <div v-if="!not_support_map" class="w-100 position-relative" :key="map_key">
                <gmap-map
                  v-if="map.center.lat != null" 
                  :center="map.center" 
                  :options="map_options"
                  :zoom="15" 
                  style="width:100%;  
                  height: 300px;"
                  @center_changed="handleMapCenterChange">
                  <gmap-marker :position="map.markers.position"></gmap-marker>
                </gmap-map>
                <div class="my-location" @click="getMyLocation()">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="my_location_24px">
                  <path id="icon/maps/my_location_24px" fill-rule="evenodd" clip-rule="evenodd" d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12Z" class="fill-primary"/>
                  </g>
                  </svg>
                </div>
              </div>
              <div class="w-100 p-4">
                <div class="d-flex justify-content-between mb-2">
                  <div class="align-items-center">
                    <p class="mb-0 body-1-4">Full Address</p>
                  </div>
                  <button class="g-btn g-btn-secondary g-btn-sm px-4 align-items-center" @click="changeDeliveryViewMode('search')">Find</button>
                </div>
                <div class="w-100 border-form radius-12 p-3 mb-3">
                  <p class="mb-0 body-2-2">{{ selected_location }}</p>
                </div>
                <div class="d-flex radius-12 border-form p-3 justify-content-between mb-3">
                  <div class="align-items-center lh-1">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="directions_24px">
                        <path id="icon/maps/directions_24px" fill-rule="evenodd" clip-rule="evenodd"
                          d="M22.4275 10.5931L13.4175 1.58312C12.6675 0.833125 11.3475 0.823125 10.5875 1.58312L1.58746 10.5831C0.807457 11.3631 0.807457 12.6231 1.58746 13.4031L10.5875 22.4031C10.9775 22.7931 11.4875 22.9831 11.9975 22.9831C12.5075 22.9831 13.0175 22.7931 13.4075 22.4031L22.3975 13.4131C23.1875 12.6531 23.1975 11.3931 22.4275 10.5931ZM12.0075 20.9931L3.00746 11.9931L12.0075 2.99312L21.0075 11.9931L12.0075 20.9931ZM7.99746 15.0031V11.0031C7.99746 10.4531 8.44746 10.0031 8.99746 10.0031H13.9975V7.50312L17.4975 11.0031L13.9975 14.5031V12.0031H9.99746V15.0031H7.99746Z"
                          class="fill-primary" />
                      </g>
                    </svg>
                  </div>
                  <input class="border-0 no-focus-border align-items-center w-90 body-2-2" v-model="specific_address" placeholder="Add landmark">
                </div>

                <!-- DISTANCE & FEE -->
                <div class="w-100 p-3 radius-12 border-form">
                  <template v-if="is_load.fee">
                    <div class="d-flex justify-content-between w-100" v-for="i in 3" :class="{
                      'mb-3 pb-3 border-b-form-dashed-2': i < 3
                    }"> 
                      <b-skeleton width="100px" height="21px"></b-skeleton>
                      <b-skeleton width="70px" height="21px"></b-skeleton>
                    </div>
                  </template>
                  
                  <template v-else>
                    <ErrorMessage v-if="fee_error != ''" :message="fee_error" />
                    <template v-else>
                      <div class="w-100 mb-3 pb-3 border-b-form-dashed-2 d-flex justify-content-between">
                        <p class="mb-0 body-2-1">Delivery Fee</p>
                        <p class="mb-0 font-lato text-14" :class="{
                          'text-danger': fee_result.error_message
                         }">{{fee_result.error_message ? 'Exceeding delivery distance' : $formatCurrency(fee_result.delivery_fee) }}</p>
                      </div>
                      <div class="w-100 mb-3 pb-3 border-b-form-dashed-2 d-flex justify-content-between">
                        <p class="mb-0 body-2-1">Distance</p>
                        <p class="mb-0 font-lato text-14">{{ fee_result.distance_text }}</p>
                      </div>
                      <div class="w-100 d-flex justify-content-between">
                        <p class="mb-0 body-2-1">Estimated arrival</p>
                        <p class="mb-0 font-lato text-14">{{ fee_result.duration_text }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="w-100 px-4 pt-4 border-t-form">
              <div class="w-100 mb-4 pb-4 border-b-form-dashed-2">
                <div class="w-100 mb-3 border-form radius-6 p-3 d-flex justify-content-between">
                  <input ref="input_find_location" type="text" class="border-0 align-items-center no-focus-border w-90 body-2-1" placeholder="Search location" v-model="search" @input="findPlace()">
                  <div class="align-items-center lh-1" @click="search = ''">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_587_22)">
                        <path
                          d="M0.228308 13.7716C0.537114 14.0717 1.04885 14.0717 1.34883 13.7716L6.99557 8.12491L12.6423 13.7716C12.9423 14.0717 13.4629 14.0805 13.7628 13.7716C14.0628 13.4629 14.0628 12.9599 13.7628 12.66L8.1161 7.0044L13.7628 1.35766C14.0628 1.05767 14.0717 0.545937 13.7628 0.245954C13.454 -0.0628521 12.9423 -0.0628521 12.6423 0.245954L6.99557 5.8927L1.34883 0.245954C1.04885 -0.0628521 0.528291 -0.0716751 0.228308 0.245954C-0.0716751 0.55476 -0.0716751 1.05767 0.228308 1.35766L5.87505 7.0044L0.228308 12.66C-0.0716751 12.9599 -0.0804984 13.4717 0.228308 13.7716Z"
                          fill="black" fill-opacity="0.85" />
                      </g>
                      <defs>
                        <clipPath id="clip0_587_22">
                          <rect width="13.9911" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <button class="g-btn g-btn-secondary-outline g-btn-sm px-4 align-items-center" @click="changeDeliveryViewMode('map')">Select via map</button>
              </div>
              <div class="w-100">
                <div v-if="is_load.search" class="py-4 text-center">
                  <loader/>
                </div>
                <template v-else>
                  <div class="w-100">
                    <ErrorMessage v-if="search_error != ''" :message="search_error" />
                    <template v-else>
                      <div class="w-100 mb-3 pb-3 border-b-form" v-for="place in search_result" @click="selectPlace(place)">
                        <p class="body-2-4 mb-0">{{ place.name }}</p>
                        <p class="body-3 mb-0">{{ place.formatted_address }}</p>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-4" v-if="!is_load.map && view_mode == 'map'">
          <state-button variant="primary" size="lg" block :click="saveAddress">
            Save address
          </state-button>
        </div>
      </template>
    </popup-detail>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get,
    post
  } from '@/services/index.js'

  export default {
    props: ['page_module','pos_id'],
    data() {
      return {
        show: false,
        specific_address: '',
        map: {
          center: { lat: null, lng: null },
          markers: {}
        },
        selected_location: '',
        debounceTimer: null,
        map_key: 0,
        is_load:{
          map: false,
          location: false,
          search: false,
          fee: true
        },
        not_support_map: false,
        map_options:{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          panControl: false,
          rotateControl: false,
          scaleControl: false,
          gestureHandling: 'greedy'
        },
        view_mode: 'map',
        debounceTimerSearch: null,
        search: '',
        search_result: [],
        search_error: '',
        selected:{
          map: {
            center: { lat: null, lng: null },
            markers: {}
          }
        },
        selected_map_options:{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          panControl: false,
          rotateControl: false,
          scaleControl: false,
          gestureHandling: 'none'
        },
        fee_result: {},
        fee_error: ''
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getOutletTrxDelivery','getRestaurantDelivery']),
      pos_code() {
        return this.$route.params.pos_code
      },
      serve_option(){
        return this.getOutletTrxDelivery.use
      },
      source_data(){
        let data = {}
        if(this.page_module == 'CUSTOM_POS'){
          data = this.$deepCopy(this.getOutletTrxDelivery)
        }else if(this.page_module == 'RESTAURANT'){
          data = this.$deepCopy(this.getRestaurantDelivery)
        }
        return data
      }
    },
    watch:{
      serve_option(){
        this.setMapSelected()
      }
    },
    mounted(){
      this.setMapSelected()
    },
    methods:{
      ...mapMutations([
        'setTrxOutletDelivery',
        'setTrxOutletDeliveryInquiry',
        'setRestaurantDelivery',
        'setRestaurantDeliveryInquiry'
      ]),
      handleMapCenterChange(newCenter){
        this.map.markers.position = {lat: newCenter.lat(), lng: newCenter.lng()}
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
          this.parsingArea() 
          this.gerCalculatedFee()
        }, 500);
      },
      toggleDelivery(){
        this.show = !this.show
        if(this.show){
          this.view_mode = 'map'
          let is_map_selected = this.$isNotEmpty(this.source_data.address.latitude) && this.$isNotEmpty(this.source_data.address.longitude) 
          if(this.source_data.use && is_map_selected){
            this.setMapPosition({
              latitude: this.source_data.address.latitude,
              longitude: this.source_data.address.longitude
            })
            this.specific_address = this.source_data.address.landmark
          }else{
            this.getMyLocation(true)
          }
        }else{
          this.map = {
            center: { lat: null, lng: null },
            markers: {}
          }
          this.selected_location = '',
          this.debounceTimer = null,
          this.map_key = 0,
          this.is_load ={
            map: false,
            location: false,
            search: false,
            fee: false
          }
          this.not_support_map = false
          this.view_mode= 'map',
          this.debounceTimerSearch= null,
          this.search= '',
          this.search_result= [],
          this.search_error= ''
          this.fee_result = {}
          this.fee_error = {}
          setTimeout(() => {
            this.setMapSelected()
          }, 300);
        }
      },
      setMapSelected(){
        let is_map_selected = this.$isNotEmpty(this.source_data.address.latitude) && this.$isNotEmpty(this.source_data.address.longitude) 
        if(this.source_data.use && is_map_selected){
          this.selected = {
            map: {
              center: { lat: this.source_data.address.latitude, lng: this.source_data.address.longitude },
              markers: { position: { lat: this.source_data.address.latitude, lng: this.source_data.address.longitude } }
            }
          }
        }
      },
      setMapPosition(position){
        var latitude = position.latitude;
        var longitude = position.longitude;

        this.map.center = {lat: latitude, lng: longitude}
        this.map.markers = { position: this.map.center }
        this.map_key++
        this.parsingArea()
        this.gerCalculatedFee()
      },
      getMyLocation(with_loading=false){
        if (navigator.geolocation) {
          let self = this
          if(with_loading) this.is_load.map = true
          
          navigator.geolocation.getCurrentPosition(
            function (position) {
              // Handle berhasil mendapatkan lokasi
              self.setMapPosition(position.coords)
              if(with_loading) self.is_load.map = false
            },
            function (error) {
              // Handle kesalahan saat mencoba mendapatkan lokasi
              self.setMapPosition({
                latitude: self.getMerchant.lat,
                longitude: self.getMerchant.lng
              })
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  console.error("Izin untuk mendapatkan lokasi ditolak oleh pengguna.");
                  break;
                case error.POSITION_UNAVAILABLE:
                  console.error("Informasi lokasi tidak tersedia.");
                  break;
                case error.TIMEOUT:
                  console.error("Waktu permintaan lokasi habis.");
                  break;
                case error.UNKNOWN_ERROR:
                  console.error("Terjadi kesalahan yang tidak diketahui.");
                  break;
              }
              if(with_loading) self.is_load.map = false
            }
          );
        } else {
          console.error("Browser tidak mendukung Geolocation API.");
          this.not_support_map = true
        }
      },
      parsingArea(){
        return new Promise((success,fail)=>{
          get("CORE","user-location",{
            lat: this.map.markers.position.lat,
            long: this.map.markers.position.lng
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.selected_location = res.data.formatted_address
              success()
            }else{
              success()
            }
          })
        })
      },
      gerCalculatedFee(){
        return new Promise((success,fail)=>{
          this.is_load.fee = true
          this.fee_error = ''

          let api_config = {
            url: 'CORE_HOTEL',
            file: `merchant-pos/${this.pos_id}/delivery-fee`
          }

          if(this.page_module == 'RESTAURANT'){
            api_config = {
              url: 'CORE_RESTO',
              file: 'v2/delivery-fee'
            }
          }
          
          post(api_config.url,api_config.file,{
            merchant_id: this.getMerchant.id,
            lat: this.map.markers.position.lat,
            long: this.map.markers.position.lng
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.fee_result = res.data
              success()
            }else{
              this.fee_error = res.message
              success()
            }
            this.is_load.fee = false
          })
        })
      },
      changeDeliveryViewMode(mode){
        this.view_mode = mode
        if(mode == 'search'){
          setTimeout(() => {
            this.$refs.input_find_location.focus()
          }, 100);
        }else{
          this.search = ''
        }
      },
      findPlace(){
        if (this.debounceTimerSearch) {
          clearTimeout(this.debounceTimerSearch);
        }

        this.debounceTimerSearch = setTimeout(() => {
          if(this.search != ''){
            this.getPlaceFromGmaps() 
          }
        }, 500);
      },
      getPlaceFromGmaps(){
        this.is_load.search = true
        this.search_error = ''
        get("CORE_HOTEL","maps-search",{
          text_search: this.search
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.search_result = res.data
          }else{
            this.search_error = res.message
          }
          this.is_load.search = false
        })
      },
      selectPlace(place){
        this.changeDeliveryViewMode('map')
        this.setMapPosition({
          latitude: place.location.lat,
          longitude: place.location.lng
        })
      },
      saveAddress(){
        return new Promise((success,fail)=>{
          setTimeout(() => {
            let params = {
              use: true,
              address:{
                latitude: this.map.markers.position.lat,
                longitude: this.map.markers.position.lng,
                full: this.selected_location,
                landmark: this.specific_address
              }
            }
            if(this.page_module == 'CUSTOM_POS'){
              this.setTrxOutletDelivery(params)
              this.setTrxOutletDeliveryInquiry(this.fee_result)
            }else if(this.page_module == 'RESTAURANT'){
              this.setRestaurantDelivery(params)
              this.setRestaurantDeliveryInquiry(this.fee_result)
            }
            this.toggleDelivery()
            success()
          }, 300);
        })
      },
    }
  }
</script>
<style>
.my-location{
  position: absolute; 
  bottom: 18px;
  right: 18px;
  height: 45px;
  width: 45px;
  display: grid;
  place-items: center;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #ccc;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/general/Delivery.vue